


























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class BaseSnackbar extends Vue {
  public show: boolean = false;

  public message: string = '';

  public error: boolean = false;

  public warning: boolean = false;

  get messages() {
    return this.message.split(',');
  }

  snackbarColor() {
    if (this.error) return 'red';
    if (this.warning) return 'amber';
    return 'green';
  }

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'Snackbar/showNotification') {
        this.message = state.Snackbar.message;
        this.error = state.Snackbar.error;
        this.warning = state.Snackbar.warning;
        this.show = true;
      }
    });
  }
}
